var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerminal = function SvgTerminal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.19002H15V1.96002H1V4.19002ZM1 5.26802V13.96H15V5.26802H1ZM1 0.960022H15C15.2652 0.960022 15.5196 1.06538 15.7071 1.25292C15.8946 1.44045 16 1.69481 16 1.96002V13.96C16 14.2252 15.8946 14.4796 15.7071 14.6671C15.5196 14.8547 15.2652 14.96 15 14.96H1C0.734783 14.96 0.480429 14.8547 0.292893 14.6671C0.105357 14.4796 0 14.2252 0 13.96V1.96002C0 1.69481 0.105357 1.44045 0.292893 1.25292C0.480429 1.06538 0.734783 0.960022 1 0.960022ZM5.56 10.972L4.997 11.619L2.717 9.59902L4.974 7.27902L5.582 7.88402L3.958 9.55202L5.56 10.972ZM10.206 10.972L11.808 9.55202L10.183 7.88402L10.792 7.28002L13.049 9.59802L10.769 11.619L10.206 10.972ZM8.829 6.32302L9.621 6.64302L7.171 12.828L6.379 12.508L8.829 6.32302Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerminal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terminal.24a1b6db.svg";
export { ForwardRef as ReactComponent };